export enum ProductStatus {
  "Disponibile",
  "Non disponibile"
}
